"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fuelInduction = void 0;
exports.getFuelInductionName = getFuelInductionName;
const lodash_1 = __importDefault(require("lodash"));
function getFuelInductionName(val) {
    let d = lodash_1.default.find(exports.fuelInduction, { type: val });
    return lodash_1.default.get(d, 'name') || '';
}
exports.fuelInduction = [
    {
        type: '1 BBL',
        name: '1-Barrel Carburetor'
    },
    {
        type: '2 BBL',
        name: '2-Barrel Carburetor'
    },
    {
        type: '3 BBL',
        name: '3-Barrel Carburetor'
    },
    {
        type: '4 BBL',
        name: '4-Barrel Carburetor'
    },
    {
        type: 'SEFI',
        name: 'Sequential Electronic Fuel Injection'
    },
    {
        type: 'SMPI',
        name: 'Sequential Multiport Fuel Injection'
    },
    {
        type: 'DI',
        name: 'Direct Injection'
    },
    {
        type: 'FI',
        name: 'Fuel Injection'
    },
    {
        type: 'CRDI',
        name: 'Common Rail Direct Injection'
    },
    {
        type: 'SPFI',
        name: 'Sequential Port Fuel Injection'
    },
    {
        type: 'PFI',
        name: 'Port Fuel Injection'
    }
];
